import axios from "@/api/axiosInstance";
import { GetBillingInvoiceDetailsResponse } from "./types";

export const getBillingInvoiceDetails = async (
  id: string,
  signal?: AbortSignal,
): Promise<GetBillingInvoiceDetailsResponse> => {
  const response = await axios.get<GetBillingInvoiceDetailsResponse>(
    `/api/private/billing/invoices/${id}`,
    { signal },
  );
  return response.data;
};
